<template>
    <div>
        <h1 class="display-heading">TPA Profile</h1>

        <div>
            <form data-vv-scope="formTPAProfileForm" ref="formTPAProfileForm" @submit.prevent="validateTPAProfileForm">
                <div class="form-group required">
                    <label>TPA Name</label>

                    <input type="text" name="tpaName" data-vv-validate-on="blur" data-vv-as="TPA name" placeholder="TPA Name" v-model="form.tpaName" v-validate="'required'" :class="{
                    'form-control': true,
                    'is-invalid':  validationErrors.has('formTPAProfileForm.tpaName')
                }">
                    <div v-show="validationErrors.has('formTPAProfileForm.tpaName')" class="invalid-feedback">
                        {{ validationErrors.first('formTPAProfileForm.tpaName') }}
                    </div>
                </div>

                <div class="form-group required">
                    <label>Notification Email Address</label>
                    <input type="text" name="email" data-vv-validate-on="blur" data-vv-as="notification email address" v-validate="'required|email'" placeholder="Notification Email Address" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('formTPAProfileForm.email')
                        }" v-model="form.tpaNotificationEmailAddress">

                    <div v-show="validationErrors.has('formTPAProfileForm.email')" class="invalid-feedback">
                        {{ validationErrors.first('formTPAProfileForm.email') }}
                    </div>
                </div>

                <div class="form-group required">
                    <label>Contact Person</label>
                    <input type="text" name="contactPerson" data-vv-validate-on="blur" data-vv-as="contact person" placeholder="Contact Person" v-validate="'required'" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('formTPAProfileForm.contactPerson')
                    }" v-model="form.tpaContactPersonName">
                    <div v-show="validationErrors.has('formTPAProfileForm.contactPerson')" class="invalid-feedback">
                        {{ validationErrors.first('formTPAProfileForm.contactPerson') }}
                    </div>
                </div>

                <div class="form-group required">
                    <label>Contact Person Phone Number</label>
                    <input type="text" name="phoneNumber" data-vv-validate-on="blur" data-vv-as="contact person phone number" placeholder="Contact Person Phone Number" v-validate="'required'" :class="{
                    'form-control': true,
                    'is-invalid':  validationErrors.has('formTPAProfileForm.phoneNumber')
                }" v-model="form.tpaContactPersonPhoneNumber">
                    <div v-show="validationErrors.has('formTPAProfileForm.phoneNumber')" class="invalid-feedback">
                        {{ validationErrors.first('formTPAProfileForm.phoneNumber') }}
                    </div>
                </div>

                <div class="form-group">
                    <div class="mt-2 mb-2">
                        <b>Company Address</b>
                    </div>
                    <div class="form-group required">
                        <label>Address Line 1</label>
                        <input type="text" name="addressLine1" data-vv-as="address line 1" data-vv-validate-on="blur" placeholder="Address Line 1" v-model="form.tpaAddressLine1" v-validate="'required'" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('formTPAProfileForm.addressLine1')
                    }">

                        <div v-show="validationErrors.has('formTPAProfileForm.addressLine1')" class="invalid-feedback">
                            {{ validationErrors.first('formTPAProfileForm.addressLine1') }}
                        </div>
                    </div>

                    <div class="form-group">
                        <label>Address Line 2</label>
                        <input type="text" class="form-control" placeholder="Address Line 2" v-model="form.tpaAddressLine2">
                    </div>

                    <div class="form-row">
                        <div class="form-group col-lg-6 col-md-6 required">
                            <label>City</label>
                            <input type="text" name="city" data-vv-validate-on="blur" placeholder="City" v-model="form.tpaAddressCity" v-validate="'required'" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('formTPAProfileForm.city')
                        }">
                            <div v-show="validationErrors.has('formTPAProfileForm.city')" class="invalid-feedback">
                                {{ validationErrors.first('formTPAProfileForm.city') }}
                            </div>
                        </div>

                        <div class="form-group col-lg-4 col-md-6 required">
                            <label>State</label>
                            <select name="state" data-vv-validate-on="blur" v-model="form.tpaAddressState" v-validate="'required'" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('formTPAProfileForm.state')
                        }">
                                <option :value="null">Choose...</option>
                                <option v-for="(state, index) in malaysiaStates" :key="index" :value="state.value">
                                    {{state.text}}
                                </option>
                            </select>
                            <div v-show="validationErrors.has('formTPAProfileForm.state')" class="invalid-feedback">
                                {{ validationErrors.first('formTPAProfileForm.state') }}
                            </div>
                        </div>

                        <div class="form-group col-lg-2 col-md-12 required">
                            <label>Postal Code</label>
                            <input type="text" name="postcode" placeholder="Postal Code" data-vv-validate-on="blur" v-model="form.tpaAddressPostcode" v-validate="'required'" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('formTPAProfileForm.postcode')
                        }">
                            <div v-show="validationErrors.has('formTPAProfileForm.postcode')" class="invalid-feedback">
                                {{ validationErrors.first('formTPAProfileForm.postcode') }}
                            </div>
                        </div>
                    </div>
                </div>

                <p v-show="isSubmitMessageShown" :class="{
                    'text-danger': isSubmitMessageError
                }">
                    {{submitMessage}}
                </p>

                <button type="button" @click="updateTPAProfile" class="btn btn-primary btn-primary-insv mr-2">Save TPA Profile</button>

                <button type="button" @click="getTPAProfile" class="btn btn-secondary">Cancel</button>
            </form>
        </div>
    </div>
</template>

<script>
import malaysiaStates from '@/config/malaysiaStates';
export default {
    'name': 'TpaProfile',
    mounted () {
        this.getTPAProfile();
    },
    data () {
        return {
            malaysiaStates,
            'form': {
                'tpaName': '',
                'tpaNotificationEmailAddress': '',
                'tpaContactPersonName': '',
                'tpaContactPersonPhoneNumber': '',
                'tpaAddressLine1': '',
                'tpaAddressLine2': '',
                'tpaAddressCity': '',
                'tpaAddressState': '',
                'tpaAddressPostcode': ''
            },
            'isSubmitMessageShown': false,
            'isSubmitMessageError': false,
            'submitMessage': ''
        };
    },
    'methods': {
        getTPAProfile () {
            this.isSubmitMessageShown = false;

            this.$validator.reset();

            this.axios.get('Tpa/Profile').then(({
                data
            }) => {
                let tpaProfile = data.data;

                if (tpaProfile != null) {
                    this.form.tpaName = tpaProfile.tn;
                    this.form.tpaNotificationEmailAddress = tpaProfile.tne;
                    this.form.tpaContactPersonName = tpaProfile.tcpn;
                    this.form.tpaContactPersonPhoneNumber = tpaProfile.tcpp;
                    this.form.tpaAddressLine1 = tpaProfile.tal1;
                    this.form.tpaAddressLine2 = tpaProfile.tal2;
                    this.form.tpaAddressCity = tpaProfile.tac;
                    this.form.tpaAddressState = tpaProfile.tas;
                    this.form.tpaAddressPostcode = tpaProfile.tap;
                }
            });
        },
        updateTPAProfile () {
            this.isSubmitMessageShown = true;
            this.isSubmitMessageError = false;
            this.validateTPAProfileForm().then((isValid) => {
                if (isValid) {
                    this.submitMessage = 'Saving TPA profile...';

                    this.axios.post('Tpa/Update', {
                        'tn': this.form.tpaName,
                        'tne': this.form.tpaNotificationEmailAddress,
                        'tcpn': this.form.tpaContactPersonName,
                        'tcpp': this.form.tpaContactPersonPhoneNumber,
                        'tal1': this.form.tpaAddressLine1,
                        'tal2': this.form.tpaAddressLine2,
                        'tac': this.form.tpaAddressCity,
                        'tas': this.form.tpaAddressState,
                        'tap': this.form.tpaAddressPostcode
                    }).then(() => {
                        this.submitMessage = 'Successfully updated TPA profile!';
                    }).catch((error) => {
                        this.isSubmitMessageError = true;
                        if (error.response.data) {
                            this.submitMessage = error.response.data.message;
                        } else {
                            this.submitMessage =
                                            'Error saving pharmacy profile. Please try again.';
                        }
                    });
                } else {
                    this.isSubmitMessageError = true;
                    this.submitMessage = 'You have error in the form. Please check your input(s) before saving TPA profile.';
                }
            });
        },
        validateTPAProfileForm () {
            return this.$validator.validateAll('formTPAProfileForm');
        }
    }
};
</script>
